import { GridRowClassNameParams, GridRowIdGetter } from '@mui/x-data-grid-pro';
import { SimData } from '../../constants/sim';

export const getRowClassName = (params: GridRowClassNameParams<SimData>) =>
  `row-${params.row.iccid}`;
export const getRowId: GridRowIdGetter<SimData> = (row) => row.iccid || Math.random();
